export default {"src":"/_next/static/media/tooltip-info.9bb375b5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};